/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RunCommandRequest = {
  sessionId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  commandRequest: components.CommandRequest;
};

/** @internal */
export const RunCommandRequest$inboundSchema: z.ZodType<
  RunCommandRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  CommandRequest: components.CommandRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CommandRequest": "commandRequest",
  });
});
/** @internal */
export type RunCommandRequest$Outbound = {
  session_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  CommandRequest: components.CommandRequest$Outbound;
};

/** @internal */
export const RunCommandRequest$outboundSchema: z.ZodType<
  RunCommandRequest$Outbound,
  z.ZodTypeDef,
  RunCommandRequest
> = z.object({
  sessionId: z.string(),
  xOnBehalfOf: z.string().optional(),
  commandRequest: components.CommandRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    xOnBehalfOf: "X-On-Behalf-Of",
    commandRequest: "CommandRequest",
  });
});

export function runCommandRequestToJSON(
  runCommandRequest: RunCommandRequest,
): string {
  return JSON.stringify(
    RunCommandRequest$outboundSchema.parse(runCommandRequest),
  );
}
export function runCommandRequestFromJSON(
  jsonString: string,
): SafeParseResult<RunCommandRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RunCommandRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RunCommandRequest' from JSON`,
  );
}
